import React, { useCallback } from 'react';

import { Form, Button, Input } from '@kufox/mui';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { REGEXP, useFormValidateByLang } from '../../common/tools';

import { useToast, useLang } from '../../hookTool';
import { NAMESPACE } from '../constants';

const { FormItem } = Form;

const ResetPwd = (props) => {
  const [form] = Form.useForm();
  const { onSuccess = _.noop } = props;
  const dispatch = useDispatch();
  const toast = useToast();
  const {
    t,
    i18n: { language },
  } = useLang();
  const handleSubmit = useCallback(async (e) => {
    e && e.preventDefault();
    // 校验表单值
    form.validateFields().then(async (values) => {
      const { password } = values;
      const isOk = await dispatch({
        type: `${NAMESPACE}/resetPwd`,
        payload: {
          password,
          toast,
        },
      });
      if (isOk) {
        onSuccess(isOk);
      }
    });
  }, []);

  useFormValidateByLang(form, language);

  return (
    <Form form={form}>
      <FormItem
        label={t('set.login.psw')}
        name="password"
        rules={[
          { required: true, whitespace: true, message: t('form.required') },
          {
            pattern: REGEXP.pwd,
            message: t('form.password.error'),
          },
        ]}
        validateTrigger={['onBlur', 'onSubmit']}
      >
        <Input type="password" size="large" />
      </FormItem>
      <Button mt={34} type="primary" fullWidth size="large" onClick={handleSubmit}>
        {t('forget.btn')}
      </Button>
    </Form>
  );
};

export default ResetPwd;
